import type { ITableTopOverviewItem } from "app/components/React/TableTopOverview/TableTopOverviewTypes";
import type { FC } from "react";
import { Item, Text } from "app/components/React/TableTopOverview/TableTopOverviewStyledComponents";
import { PlainTooltip } from "@similarweb/ui-components";
import { NumberValue } from "app/components/React/TableTopOverview/ValueComponents/NumberValue";
import { SWReactIcons } from "@similarweb/icons";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const TableTopOverviewItem: FC<ITableTopOverviewItem> = ({
    component = NumberValue,
    isLoading,
    value,
    tooltipContent,
    tooltipEnabled,
    itemAttributes,
    text = "",
    textAttributes = {},
}) => {
    const ItemComponent = component;

    const textComponent = text ? <Text {...textAttributes}>{text}</Text> : <Text {...textAttributes} />;

    return (
        <Item {...itemAttributes}>
            <ItemComponent isLoading={isLoading}>{value}</ItemComponent>
            {tooltipContent && tooltipEnabled ? (
                <CenteredFlexRow>
                    {textComponent}
                    <PlainTooltip
                        tooltipContent={tooltipContent}
                        enabled={tooltipEnabled}
                        placement="bottom"
                    >
                        <span>
                            <SWReactIcons
                                size={"xs"}
                                iconName={"info"}
                            />
                        </span>
                    </PlainTooltip>
                </CenteredFlexRow>
            ) : (
                textComponent
            )}
        </Item>
    );
};
